import { Injectable, inject } from '@angular/core';

import { TrackingValueService } from '@payments/common-utils';
import { Subscription } from 'rxjs';

import { UrlConstants } from '../config/urlConstants';
import { DataService } from './data.service';
import { QdApiService } from './qd.service';
import { UserDataService } from './userDataService';

@Injectable({
    providedIn: 'root',
})
export class ApplePayValidatorService {
    private apiService = inject(QdApiService);
    private userDataService = inject(UserDataService);
    dataService = inject(DataService);

    validationURL: string;
    txnId: string;
    processorTxnID: string;
    session: ApplePaySession;
    userDataInfo: any;
    getUserDataInfo: Subscription = new Subscription();
    supportedNetworks: any = null;
    private trackingValueService = inject(TrackingValueService);

    getPaymentRequest(creditCardBanEnabled: string, countryCode: string, currencyCode: string, amount: string): any {
        const paymentRequest: any = {};
        paymentRequest.countryCode = countryCode;
        paymentRequest.currencyCode = currencyCode;
        paymentRequest.total = {};
        paymentRequest.total.label = '';
        paymentRequest.total.amount = amount;
        if (this.userDataService?.userData?.configParams && this.userDataService?.userData?.configParams.supportedNetworks) {
            const supportedNetworksSplit = this.userDataService?.userData?.configParams.supportedNetworks.split(',');
            paymentRequest.supportedNetworks = supportedNetworksSplit;
        } else {
            paymentRequest.supportedNetworks = ['masterCard', 'visa', 'maestro', 'amex'];
        }
        paymentRequest.merchantCapabilities = creditCardBanEnabled === 'Y' ? ['supports3DS', 'supportsDebit'] : ['supports3DS'];

        return paymentRequest;
    }

    processApplePayDeposit(depositSubmitReq: any, creditCardBanEnabled: string, countryCode: string) {
        // Set country code and card ban

        let paymentRequest: any = null;
        const userInfo = this.dataService.sessionInfo;
        // eslint-disable-next-line no-console
        console.log('countryCode ***', countryCode);
        if ('ApplePaySession' in window && ApplePaySession.canMakePayments() === true) {
            // eslint-disable-next-line no-console
            console.log('ApplePaySession');
            try {
                // eslint-disable-next-line no-console
                console.log('userDataService***', this.userDataService);
                if (this.userDataService?.userData?.configParams && this.userDataService?.userData?.configParams.supportedNetworks) {
                    const supportedNetworksSplit = this.userDataService?.userData?.configParams.supportedNetworks.split(',');
                    this.supportedNetworks = supportedNetworksSplit;
                }

                if ('Y' === creditCardBanEnabled) {
                    paymentRequest = {
                        countryCode: countryCode,
                        currencyCode: depositSubmitReq.amountInfo.nativeCurrency,
                        total: {
                            label: '',
                            amount: depositSubmitReq.amountInfo.nativeAmountString + '',
                        },
                        supportedNetworks: this.supportedNetworks ? this.supportedNetworks : ['masterCard', 'visa', 'maestro', 'discover'],
                        merchantCapabilities: ['supports3DS', 'supportsDebit'],
                    };
                } else {
                    paymentRequest = {
                        countryCode: countryCode,
                        currencyCode: depositSubmitReq.amountInfo.nativeCurrency,
                        total: {
                            label: '',
                            amount: depositSubmitReq.amountInfo.nativeAmountString + '',
                        },

                        supportedNetworks:
                            this.supportedNetworks && this.supportedNetworks !== null
                                ? this.supportedNetworks
                                : ['masterCard', 'visa', 'maestro', 'amex', 'discover'],
                        merchantCapabilities: ['supports3DS'],
                    };
                }
                // eslint-disable-next-line no-console
                console.log('paymentRequest ***', paymentRequest);
                const session = new ApplePaySession(1, paymentRequest);
                // eslint-disable-next-line no-console
                console.log('session ***', session);
                session.onvalidatemerchant = (event) => {
                    try {
                        // eslint-disable-next-line no-console
                        console.log('session In  try***', event);
                        this.validationURL = event.validationURL;
                        depositSubmitReq.paymentAccountInfo.validationURL = this.validationURL;
                        if (depositSubmitReq?.details) {
                            depositSubmitReq.details.GA_CLIENT_ID = this.trackingValueService?.gaClientId;
                            depositSubmitReq.details.GA_SESSION_ID = this.trackingValueService?.gaSessionId;
                        } else {
                            depositSubmitReq.details = {
                                GA_SESSION_ID: this.trackingValueService?.gaSessionId,
                                GA_CLIENT_ID: this.trackingValueService?.gaClientId,
                            };
                        }
                        // eslint-disable-next-line no-console
                        console.log('DEPOSIT_SUBMIT_URI response');
                        this.apiService
                            .post(
                                UrlConstants.DEPOSIT_SUBMIT_URI + `?language=${userInfo && userInfo.LANG_ID ? userInfo.LANG_ID : 'en'}&source=PG`,
                                depositSubmitReq,
                            )
                            .toPromise()
                            .then((response) => {
                                // eslint-disable-next-line no-console
                                console.log('DEPOSIT_SUBMIT_URI response : ', response);
                                this.txnId = response.transactionId;
                                this.processorTxnID = response.postData.processorTxnID;
                                const deviceSession = response.postData.DeviceFingerprintingSessionID;
                                const responseSession = JSON.parse(deviceSession);
                                session.completeMerchantValidation(responseSession);
                            })
                            .catch((err) => {
                                this.apiService
                                    .get(UrlConstants.EXCEPTION_END_URI + '?log=Exception occured in Applepay deposit Submit' + err)
                                    .subscribe(
                                        (response) => {
                                            // eslint-disable-next-line no-console
                                            console.log(response);
                                        },
                                        () => {},
                                    );
                            });
                    } catch (e) {
                        this.apiService
                            .get(
                                UrlConstants.EXCEPTION_END_URI +
                                    '?log=Exception in validate Merchant for paymentRequest ' +
                                    JSON.stringify(paymentRequest) +
                                    ' with exception ' +
                                    e,
                            )
                            .subscribe(
                                (response) => {
                                    // eslint-disable-next-line no-console
                                    console.log(response);
                                },
                                () => {},
                            );
                    }
                };

                session.onpaymentauthorized = (event) => {
                    // eslint-disable-next-line no-console
                    console.log('IN onpaymentauthorized');
                    const payload = JSON.stringify(event.payment);
                    const dataString =
                        '?transactionId=' + this.txnId + '&processorTxnID=' + this.processorTxnID + '&tokenPayLoad=' + encodeURIComponent(payload);
                    this.apiService
                        .get(UrlConstants.APPLEPAY_EXECUTE + dataString)
                        .toPromise()
                        .then((response) => {
                            if (response) {
                                const responseCode = response.responseCode;
                                if (responseCode === '0') {
                                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                                    this.checkDepositStatus();
                                } else {
                                    session.abort();
                                    this.checkDepositStatus();
                                }
                            }
                        })
                        .catch((err) => {
                            session.abort();
                            this.apiService
                                .get(
                                    UrlConstants.EXCEPTION_END_URI +
                                        '?log=Exception in validate Merchant for paymentRequest ' +
                                        JSON.stringify(paymentRequest) +
                                        ' with exception ' +
                                        err,
                                )
                                .subscribe(
                                    (response) => {
                                        // eslint-disable-next-line no-console
                                        console.log(response);
                                    },
                                    () => {},
                                );
                        });
                };
                session.begin();
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log('In  Exception  Block ***');
                this.apiService
                    .get(
                        UrlConstants.EXCEPTION_END_URI +
                            '?log=Exception in validate Merchant for paymentRequest ' +
                            JSON.stringify(paymentRequest) +
                            ' with exception ' +
                            e,
                    )
                    .subscribe(
                        (response) => {
                            // eslint-disable-next-line no-console
                            console.log(response);
                        },
                        () => {},
                    );
            }
        }
    }

    checkDepositStatus = () => {
        try {
            this.apiService.get(UrlConstants.DEPOSIT_STATUS_URI + '/' + this.txnId).subscribe(
                (response: any) => {
                    if (response.status && response.status === 'SUCCESS') {
                        if (response.status == 'SUCCESS') {
                            this.dataService._callSuccessApi = true;
                        }
                        // this.depositSuccessService.setSuccessResponse(response);
                        // this.global.submitDepositResponse.next(response);
                        // this.global.appliedBonusCode.next(response.bonusCode);
                        // //this.router.navigate(["/deposit/deposit-success"]);
                    }
                },
                () => {},
            );
        } catch (e) {
            this.apiService.get(UrlConstants.EXCEPTION_END_URI + '?log=Exception Occured In checkDepositStatus of applepay' + e).subscribe(
                (response: any) => {
                    // eslint-disable-next-line no-console
                    console.log(response);
                },
                () => {},
            );
        }
    };
}
